"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const intl_localematcher_1 = require("@formatjs/intl-localematcher");
const negotiator_1 = __importDefault(require("negotiator"));
function localeDetector(request, config) {
    const negotiatorHeaders = {};
    request.headers.forEach((value, key) => (negotiatorHeaders[key] = value));
    const languages = new negotiator_1.default({ headers: negotiatorHeaders }).languages();
    // match can only use specifically formatted locales
    // https://stackoverflow.com/questions/76447732/nextjs-13-i18n-incorrect-locale-information-provided
    try {
        return (0, intl_localematcher_1.match)(languages, config.locales, config.defaultLocale);
    }
    catch (e) {
        // invalid accept-language header
        return config.defaultLocale;
    }
}
exports.default = localeDetector;
//# sourceMappingURL=localeDetector.js.map